var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_878_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2143 2.78571H20.4286V0.928589C20.4286 0.415735 20.0128 0 19.5 0C18.9871 0 18.5714 0.415735 18.5714 0.928589V2.78571H7.42855V0.928589C7.42855 0.415735 7.01281 0 6.50001 0C5.98721 0 5.57142 0.415735 5.57142 0.928589V2.78571H2.78571C1.2472 2.78571 0 4.03292 0 5.57142V23.2143C0 24.7528 1.2472 26 2.78571 26H23.2143C24.7528 26 26 24.7528 26 23.2143V5.57142C26 4.03292 24.7528 2.78571 23.2143 2.78571ZM24.1428 23.2143C24.1428 23.7271 23.7271 24.1429 23.2142 24.1429H2.78571C2.27286 24.1429 1.85712 23.7271 1.85712 23.2143V11.1428H24.1428V23.2143ZM24.1428 9.28573H1.85712V5.57142C1.85712 5.05857 2.27286 4.64284 2.78571 4.64284H5.57142V6.49996C5.57142 7.01281 5.98716 7.42855 6.50001 7.42855C7.01287 7.42855 7.4286 7.01281 7.4286 6.49996V4.64284H18.5715V6.49996C18.5715 7.01281 18.9872 7.42855 19.5 7.42855C20.0129 7.42855 20.4286 7.01281 20.4286 6.49996V4.64284H23.2143C23.7272 4.64284 24.1429 5.05857 24.1429 5.57142V9.28573H24.1428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42634 13H5.56921C5.05636 13 4.64062 13.4157 4.64062 13.9286C4.64062 14.4414 5.05636 14.8572 5.56921 14.8572H7.42634C7.93919 14.8572 8.35493 14.4414 8.35493 13.9286C8.35493 13.4157 7.93919 13 7.42634 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9263 13H12.0692C11.5564 13 11.1406 13.4157 11.1406 13.9286C11.1406 14.4414 11.5564 14.8572 12.0692 14.8572H13.9263C14.4392 14.8572 14.8549 14.4414 14.8549 13.9286C14.8549 13.4157 14.4392 13 13.9263 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4263 13H18.5692C18.0564 13 17.6406 13.4157 17.6406 13.9286C17.6406 14.4414 18.0564 14.8572 18.5692 14.8572H20.4263C20.9392 14.8572 21.3549 14.4414 21.3549 13.9286C21.3549 13.4157 20.9391 13 20.4263 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42634 16.7139H5.56921C5.05636 16.7139 4.64062 17.1296 4.64062 17.6425C4.64062 18.1553 5.05636 18.571 5.56921 18.571H7.42634C7.93919 18.571 8.35493 18.1553 8.35493 17.6425C8.35493 17.1296 7.93919 16.7139 7.42634 16.7139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9263 16.7139H12.0692C11.5564 16.7139 11.1406 17.1296 11.1406 17.6425C11.1406 18.1553 11.5564 18.571 12.0692 18.571H13.9263C14.4392 18.571 14.8549 18.1553 14.8549 17.6425C14.8549 17.1296 14.4392 16.7139 13.9263 16.7139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4263 16.7139H18.5692C18.0564 16.7139 17.6406 17.1296 17.6406 17.6425C17.6406 18.1553 18.0564 18.571 18.5692 18.571H20.4263C20.9392 18.571 21.3549 18.1553 21.3549 17.6425C21.3549 17.1296 20.9391 16.7139 20.4263 16.7139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42634 20.4287H5.56921C5.05636 20.4287 4.64062 20.8444 4.64062 21.3573C4.64062 21.8702 5.05636 22.2858 5.56921 22.2858H7.42634C7.93919 22.2858 8.35493 21.8701 8.35493 21.3572C8.35493 20.8444 7.93919 20.4287 7.42634 20.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9263 20.4287H12.0692C11.5564 20.4287 11.1406 20.8444 11.1406 21.3573C11.1406 21.8702 11.5564 22.2859 12.0692 22.2859H13.9263C14.4392 22.2859 14.8549 21.8702 14.8549 21.3573C14.8549 20.8444 14.4392 20.4287 13.9263 20.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4263 20.4287H18.5692C18.0564 20.4287 17.6406 20.8444 17.6406 21.3573C17.6406 21.8702 18.0564 22.2859 18.5692 22.2859H20.4263C20.9392 22.2859 21.3549 21.8702 21.3549 21.3573C21.3549 20.8444 20.9391 20.4287 20.4263 20.4287Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.35132485e3574c5b62d553cbcd5c9d31.svg";
export { ForwardRef as ReactComponent };